<template>
  <div class="">
    <div class="mt-2" :style="{ 'margin-right': `${margin}px` }">
      <input
          @change="filterByCategory"
          :checked="selectedCategory.indexOf(category.id.toString()) > -1"
          type="checkbox"
          :value="category.id"
          :id="`${categoryId}_${category.id}`"
      />
      <label class="mr-1" :for="`${categoryId}_${category.id}`">
        {{ category.name }}
      </label>
      <b-icon icon="arrow-down-circle" class="mr-2" v-b-toggle="'collapse-'+category.id" v-if="category.children.length" />
    </div>

   <b-collapse :id="'collapse-'+category.id">
     <category
         :remove-category="removeCategory"
         :filterAction="filterAction"
         :selected-category="selectedCategory"
         v-for="children in category.children"
         :margin="margin + 15"
         :key="children.id"
         :categoryId="categoryId"
         :category="children"
     />
   </b-collapse>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "category",
  props: [
    "category",
    "margin",
    "selectedCategory",
    "removeCategory",
    "categoryId",
    "filterAction"
  ],
  methods: {
    filterByCategory(e) {
      const value = e.target.value;
      const query = Object.assign({}, router.currentRoute.query);
      const selectedCategories = this.$store.getters['Product/getFilter']("category")

      if (e.target.checked) {
        selectedCategories.push(value);
        this.$store.commit('Product/setFilters',{key:'category' , value:selectedCategories})
        console.log(selectedCategories)
      } else {
        selectedCategories.splice(selectedCategories.indexOf(value), 1);
        this.$store.commit('Product/setFilters',{key:'category' , value:selectedCategories})
        console.log(selectedCategories)
      }

      if (this.selectedCategory.length > 0) {
        query.category = this.selectedCategory.join(",");
        router.push({
          name: "Products",
          query: {...router.currentRoute.query, category: query.category},
        });
      } else {
        delete query.category;
        router.push({
          name: "Products",
          query: query,
        });
      }
      this.filterAction();
    },
  },

  mounted() {
  },
};
</script>

<style scoped>
</style>